import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ItemView from '../utils/ItemView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Enums from '../../enums';

class AdsCreateApp extends React.Component {
    constructor() {
        super();
        Tools.init();
        API.init(this);

        const tmp = [
            {
                type: Enums.E_ITEM.OPTION,
                data: {
                    label: '廣告類型',
                    neccessary: true,
                    options: [
                        [1, "外部網站連結"],
                        [2, "跳轉問卷編號"],
                        [3, "跳轉商品編號"]
                    ],
                    value: 0
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: '贈送E幣',
                    neccessary: true,
                    value: 0
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                data: {
                    label: '廣告標題',
                    neccessary: true,
                    value: "測測"
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: '贈送金幣',
                    value: 0
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                data: {
                    label: '廣告副標題',
                    neccessary: true,
                    value: "這是測試"
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                col: 1,
                data: {
                    label: '影片連結',
                    value: ""
                }
            }, {
                type: Enums.E_ITEM.TIME,
                data: {
                    label: '上架日期',
                    neccessary: true,
                    value: 1577711600000
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                col: 1,
                data: {
                    label: '跳轉目的地',
                    value: ""
                }
            }, {
                type: Enums.E_ITEM.TIME,
                data: {
                    label: '下架日期',
                    neccessary: true,
                    value: 1577721600000
                }
            }, {
                type: Enums.E_ITEM.TEXTAREA,
                col: 1,
                data: {
                    label: '廣告主文',
                    neccessary: true,
                    value: "這是測試主文"
                }
            }, {
                type: Enums.E_ITEM.RADIO,
                col: 1,
                data: {
                    label: '置頂',
                    neccessary: true,
                    options: [[1, "是"], [0, "否"]],
                    value: 0
                }
            }, {
                type: Enums.E_ITEM.RADIO,
                col: 1,
                data: {
                    label: '強力推薦',
                    neccessary: true,
                    options: [[1, "是"], [0, "否"]],
                    value: 0
                }
            }, {
                type: Enums.E_ITEM.RADIO,
                col: 1,
                data: {
                    label: '刪除',
                    neccessary: true,
                    options: [[1, "是"], [0, "否"]],
                    value: 0
                }
            }, {
                type: Enums.E_ITEM.IMAGE,
                data: {
                    label: '廣告主圖',
                    neccessary: true,
                    value: "https://atlasturf.com.au/wp-content/uploads/2016/05/sapphire-soft-leaf-buffalo-turf-sydney.jpg"
                }
            }, {
                type: Enums.E_ITEM.TEXTAREA,
                col: 1,
                data: {
                    label: '廣告補充內容',
                    value: ""
                }
            }, {
                type: Enums.E_ITEM.IMAGE,
                data: {
                    label: '廣告附圖',
                    value: ""
                }
            }, {
                type: Enums.E_ITEM.IMAGE,
                data: {
                    label: '廣告主文圖',
                    value: ""
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                col: 1,
                data: {
                    label: '來源',
                    neccessary: true,
                    value: "test"
                }
            }
        ];

        this.state = {
            ty: 1,
            list: tmp
        };

        this.onItemViewUpdated = this.onItemViewUpdated.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onPreview = this.onPreview.bind(this);
    }

    onItemViewUpdated(index, value) {
        // console.log(index, value);
        let list = Object.assign({}, this.state.list);
        list[index].data.value = value;
        this.setState({ list: list });
    }

    checkNecessary() {
        let list = Object.assign({}, this.state.list),
            result = true;
        for (let i in list) {
            let obj = list[i];
            delete obj.data.isError;
            if (true == obj.data.neccessary) {
                if (null == obj.data.value) {
                    result = false;
                    obj.data.isError = true;
                }
                switch (obj.type) {
                    case Enums.E_ITEM.TEXT:
                    case Enums.E_ITEM.TEXTAREA:
                        if (typeof (obj.data.value) != "string" ||
                            0 == obj.data.value.length
                        ) {
                            result = false;
                            obj.data.isError = true;
                        }
                        break;
                    case Enums.E_ITEM.TIME:
                    case Enums.E_ITEM.NUMBER:
                        if (isNaN(parseInt(obj.data.value))
                        ) {
                            result = false;
                            obj.data.isError = true;
                        }
                        break;
                }
            }
        }
        this.setState({ list: list });
        return result;
    }

    onPreview() {
        if (false == this.checkNecessary()) {
            alert("資料錯誤");
            return;
        }

        console.log("onPreview");
        const list = this.state.list;
        const header = {
            ty: 1, //功能(0=新增, 1=預覽, 2=修改)
        };
        const body = {
            'ad_type': list[0].data.value,
            'point': list[1].data.value,
            'name': list[2].data.value,
            'cash_point': list[3].data.value,
            'sub_name': list[4].data.value,
            'video': list[5].data.value,
            'start_at': list[6].data.value,
            'link': list[7].data.value,
            'end_at': list[8].data.value,
            'description': list[9].data.value,
            'is_top': list[10].data.value,
            'is_recom': list[11].data.value,
            'is_del': list[12].data.value,
            'icon': list[13].data.value,
            'add_desc': list[14].data.value,
            'images': [list[15].data.value],
            'images2': [list[16].data.value],
            source: "text"
        };

        console.log(header, body);
        API.AddAds(header, body, function (res) {
            console.log(res);
        });
    }

    onSave() {
        if (false == this.checkNecessary()) {
            alert("資料錯誤");
            return;
        }

        console.log("onSave");
        const list = this.state.list;
        const header = {
            ty: 0, //功能(0=新增, 1=預覽, 2=修改)
        };
        const body = {
            'ad_type': list[0].data.value,
            'point': list[1].data.value,
            'name': list[2].data.value,
            'cash_point': list[3].data.value,
            'sub_name': list[4].data.value,
            'video': list[5].data.value,
            'start_at': list[6].data.value,
            'link': list[7].data.value,
            'end_at': list[8].data.value,
            'description': list[9].data.value,
            'is_top': list[10].data.value,
            'is_recom': list[11].data.value,
            'is_del': list[12].data.value,
            'icon': list[13].data.value,
            'add_desc': list[14].data.value,
            'images': [list[15].data.value],
            'images2': [list[16].data.value],
            'source': list[17].data.value
        };

        console.log(header, body);
        // alert("沒有更新api");
        API.AddAds(header, body, function (res) {
            console.log(res);
        }, function (data) {
            try {
                alert(data.responseJSON.msg)
            } catch (e) { }
        });
    }

    render() {
        const { list } = this.state,
            { onItemViewUpdated, onSave, onPreview } = this;
        return (
            <div>
                <ItemView
                    title={"新增廣告"}
                    onUpdate={onItemViewUpdated}
                    onSave={onSave}
                    onPreview={onPreview}
                    disableEdit={true}
                    disableDelete={true}
                    enabled={true}
                    data={list} />
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(AdsCreateApp),
//     document.getElementById('root')
// );


const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AdsCreateApp))